export function stop(event: React.SyntheticEvent) {
  event.stopPropagation();
  return event;
}
